import { render } from "./ModalLocalizacao.vue?vue&type=template&id=a27dd1ca"
import script from "./ModalLocalizacao.vue?vue&type=script&lang=js"
export * from "./ModalLocalizacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__